import { ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { setCustomGrowthAmount } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/custom-growth-amount/custom-growth-amount.actions';
import { setFundChartFormat } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/format/format.actions';
import { CHART_FORMAT_CURRENCY_GROWTH, DEFAULT_CUSTOM_GROWTH_AMOUNT, FORMAT_OPTIONS, MAX_CUSTOM_GROWTH_AMOUNT, MIN_CUSTOM_GROWTH_AMOUNT, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { FIGURE_WHOLE, getFormatter } from 'Angular/utils/number_formatter';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["growthAmountInput"];
const _c1 = a0 => ({ "is-editing": a0 });
function FundChartDataFormatComponent_div_9_div_6_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.customGrowthAmountErrorMessage, " ");
} }
function FundChartDataFormatComponent_div_9_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "div", 15);
    i0.ɵɵtext(3, " $");
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 16);
    i0.ɵɵlistener("click", function FundChartDataFormatComponent_div_9_div_6_Template_div_click_7_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.setEditingCustomGrowth(true)); });
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 17);
    i0.ɵɵelementEnd()()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(10, "div", 18)(11, "input", 19, 1);
    i0.ɵɵtwoWayListener("ngModelChange", function FundChartDataFormatComponent_div_9_div_6_Template_input_ngModelChange_11_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r3.customGrowthAmount, $event) || (ctx_r3.customGrowthAmount = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function FundChartDataFormatComponent_div_9_div_6_Template_input_ngModelChange_11_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.validateChartCustomGrowthAmount(ctx_r3.customGrowthAmount)); })("blur", function FundChartDataFormatComponent_div_9_div_6_Template_input_blur_11_listener() { i0.ɵɵrestoreView(_r5); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.setChartCustomGrowthAmount(ctx_r3.customGrowthAmount)); })("keydown.enter", function FundChartDataFormatComponent_div_9_div_6_Template_input_keydown_enter_11_listener() { i0.ɵɵrestoreView(_r5); const growthAmountInput_r6 = i0.ɵɵreference(12); return i0.ɵɵresetView(growthAmountInput_r6.blur()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, FundChartDataFormatComponent_div_9_div_6_div_13_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1, ctx_r3.editingCustomGrowthAmount));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 9, ctx_r3.customGrowthAmount));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", "Edit");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-edit");
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.customGrowthAmount);
    i0.ɵɵproperty("min", ctx_r3.minCustomGrowthAmount)("max", ctx_r3.maxCustomGrowthAmount);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.growthAmountIsValid);
} }
function FundChartDataFormatComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 8)(2, "input", 9);
    i0.ɵɵtwoWayListener("ngModelChange", function FundChartDataFormatComponent_div_9_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r3.dataFormat, $event) || (ctx_r3.dataFormat = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function FundChartDataFormatComponent_div_9_Template_input_ngModelChange_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.setChartDataFormat(ctx_r3.dataFormat)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 10);
    i0.ɵɵelementStart(4, "span", 11);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, FundChartDataFormatComponent_div_9_div_6_Template, 14, 13, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3.dataFormat);
    i0.ɵɵproperty("value", option_r7.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r7.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dataFormat === ctx_r3.currencyGrowthDataFormat && option_r7.value === ctx_r3.currencyGrowthDataFormat);
} }
/**
 *
 * Fund Chart Data Format Component
 *
 */
export class FundChartDataFormatComponent {
    constructor(store) {
        this.store = store;
        this.currencyGrowthDataFormat = CHART_FORMAT_CURRENCY_GROWTH;
        this.customGrowthAmount = DEFAULT_CUSTOM_GROWTH_AMOUNT;
        this.customGrowthAmountErrorMessage = '';
        this.editingCustomGrowthAmount = false;
        this.formatOptions = FORMAT_OPTIONS;
        this.growthAmountIsValid = true;
        this.maxCustomGrowthAmount = MAX_CUSTOM_GROWTH_AMOUNT;
        this.minCustomGrowthAmount = MIN_CUSTOM_GROWTH_AMOUNT;
        this.mapStateToComponent = (state) => {
            const { customGrowthAmount, format } = state.fundChart;
            this.dataFormat = format;
            if (customGrowthAmount) {
                this.customGrowthAmount = customGrowthAmount;
                this.validateChartCustomGrowthAmount(this.customGrowthAmount);
            }
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
        const minGrowthAmountFormatted = getFormatter(FIGURE_WHOLE)(this.minCustomGrowthAmount);
        const maxGrowthAmountFormatted = getFormatter(FIGURE_WHOLE)(this.maxCustomGrowthAmount);
        this.customGrowthAmountErrorMessage = `Growth amount must be a whole number between ${minGrowthAmountFormatted} and ${maxGrowthAmountFormatted}.`;
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    setChartDataFormat(format) {
        this.store.dispatch(setFundChartFormat({ format }));
        const customGrowthAmount = format === CHART_FORMAT_CURRENCY_GROWTH ? this.customGrowthAmount : null;
        this.setChartCustomGrowthAmount(customGrowthAmount);
    }
    /**
     * Calls action to set Custom Growth state.
     * To either update amount on growth format, or
     * reset state when switching to a different format
     * @param customGrowthAmount
     */
    setChartCustomGrowthAmount(customGrowthAmount = null) {
        const removeGrowthFormat = this.dataFormat !== CHART_FORMAT_CURRENCY_GROWTH && !customGrowthAmount;
        if (removeGrowthFormat || this.growthAmountIsValid) {
            this.setEditingCustomGrowth(false);
            this.store.dispatch(setCustomGrowthAmount({
                customGrowthAmount: customGrowthAmount ? Math.floor(customGrowthAmount) : customGrowthAmount,
            }));
        }
    }
    setEditingCustomGrowth(isOpen) {
        this.editingCustomGrowthAmount = isOpen;
        if (this.editingCustomGrowthAmount) {
            setTimeout(() => {
                this.growthAmountInput.nativeElement.focus();
            });
        }
    }
    validateChartCustomGrowthAmount(customGrowthAmount) {
        this.growthAmountIsValid =
            Number.isInteger(customGrowthAmount) &&
                MIN_CUSTOM_GROWTH_AMOUNT <= customGrowthAmount &&
                customGrowthAmount <= MAX_CUSTOM_GROWTH_AMOUNT;
    }
}
FundChartDataFormatComponent.ɵfac = function FundChartDataFormatComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartDataFormatComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
FundChartDataFormatComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartDataFormatComponent, selectors: [["ycn-fund-chart-data-format"]], viewQuery: function FundChartDataFormatComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.growthAmountInput = _t.first);
    } }, standalone: false, decls: 10, vars: 1, consts: [["helpModal", ""], ["growthAmountInput", ""], [1, "panel-sidebar-section-header", "user-select-none"], [1, "panel-sidebar-section-title"], [1, "help-toggler", 3, "click"], [1, "panel-sidebar-section-body", "user-select-none"], [1, "custom-controls-stacked"], [4, "ngFor", "ngForOf"], [1, "custom-control", "custom-radio"], ["type", "radio", 1, "custom-control-input", 3, "ngModelChange", "ngModel", "value"], [1, "custom-control-indicator"], [1, "custom-control-description"], ["class", "pl-20 mb-1", 4, "ngIf"], [1, "pl-20", "mb-1"], [1, "form-group-editable", "form-group-editable-bordered", 3, "ngClass"], [1, "form-value"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "tooltipPlacement", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "input-group"], ["type", "number", "placeholder", "Enter value", 1, "form-control", "width-full", 3, "ngModelChange", "blur", "keydown.enter", "ngModel", "min", "max"], ["class", "feedback feedback-invalid", 4, "ngIf"], [1, "feedback", "feedback-invalid"]], template: function FundChartDataFormatComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
        i0.ɵɵtext(2, " Data Format ");
        i0.ɵɵelementStart(3, "span", 4);
        i0.ɵɵlistener("click", function FundChartDataFormatComponent_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(6); return i0.ɵɵresetView(helpModal_r2.openModal("data_formats")); });
        i0.ɵɵtext(4, "(?)");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "ycn-help-modal", null, 0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
        i0.ɵɵtemplate(9, FundChartDataFormatComponent_div_9_Template, 7, 4, "div", 7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngForOf", ctx.formatOptions);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.DefaultValueAccessor, i3.NumberValueAccessor, i3.RadioControlValueAccessor, i3.NgControlStatus, i3.MinValidator, i3.MaxValidator, i3.NgModel, i4.HelpModalComponent, i5.IconDirective, i6.TooltipDirective, i2.DecimalPipe], encapsulation: 2 });
